module.exports = __webpack_public_path__ + "static/media/Calculator.20a99eb6.svg";